module.exports = __webpack_public_path__ + "static/img/logo_13988_new.c3cdecd.png";


//////////////////
// WEBPACK FOOTER
// ./static/logo/logo_13988_new.png
// module id = 59db
// module chunks = 167